/**
 * Tier Pricing System - Click pe rânduri + Event Listeners
 * - Click pe rând → setează cantitatea
 * - Change pe quantity input → actualizează afișajul
 * - Calcul în timp real fără polling
 */

(function() {
  'use strict';
  
  console.log('TierPricing: Mod INTERACTIV - click pe rânduri + event listeners');
  
  // Inițializare la încărcarea paginii
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initTierPricing();
    });
  } else {
    initTierPricing();
  }
  
  function initTierPricing() {
    // Verifică dacă suntem în pagina de cart
    if (document.body.classList.contains('template-cart') || 
        window.location.pathname.includes('/cart')) {
      console.log('TierPricing: Dezactivat în cart');
      return;
    }
    
    // Găsește toate produsele cu tier pricing
    const tierPricingElements = document.querySelectorAll('.product-tier-pricing');
    if (tierPricingElements.length === 0) return;
    
    tierPricingElements.forEach(function(element) {
      const productId = element.getAttribute('data-product-id');
      const dataElement = document.getElementById('tier-pricing-data-' + productId);
      
      if (!dataElement) return;
      
      let tierData;
      try {
        tierData = JSON.parse(dataElement.textContent);
      } catch(e) {
        console.error('TierPricing: Eroare la parsare', e);
        return;
      }
      
      if (!tierData || tierData.length === 0) return;
      
      // Găsește input-ul de cantitate - caută în mai multe locuri
      let quantityInput = document.querySelector('input[name="quantity"]');
      if (!quantityInput) {
        quantityInput = document.querySelector('.product-form__quantity input');
      }
      if (!quantityInput) {
        quantityInput = document.querySelector('.quantity-selector input');
      }
      
      if (!quantityInput) {
        console.log('TierPricing: Nu s-a găsit input-ul de cantitate');
        return;
      }
      
      console.log('TierPricing: Input găsit:', quantityInput);
      
      // Funcție pentru actualizare afișaj în timp real
      function updateDisplay(quantity) {
        quantity = parseInt(quantity) || 1;
        
        // Găsește tier-ul potrivit
        const tier = getTierForQuantity(quantity, tierData);
        const unitPrice = tier.price * 100; // cents
        const totalPrice = unitPrice * quantity;
        
        // Actualizează afișajul preț/total
        const displayElement = document.querySelector('.current-tier-display');
        if (displayElement) {
          displayElement.style.display = 'block';
          displayElement.innerHTML = 
            '<div class="alert alert-info">' +
              '<strong>Preț pentru ' + quantity + ' buc:</strong> ' + formatMoney(unitPrice) + ' / buc<br>' +
              '<strong>Total estimat:</strong> ' + formatMoney(totalPrice) +
              '<br><small style="color: #28a745;"><i class="fa fa-check-circle"></i> Reducerile se aplică AUTOMAT în coș!</small>' +
            '</div>';
        }
        
        // Evidențiază rândul activ
        highlightActiveTier(tier, productId);
        
        console.log('TierPricing: Afișaj actualizat - qty:', quantity, 'tier:', tier);
      }
      
      // EVENT LISTENERS pentru quantity input - toate event-urile posibile
      quantityInput.addEventListener('input', function() {
        updateDisplay(this.value);
      });
      
      quantityInput.addEventListener('change', function() {
        updateDisplay(this.value);
      });
      
      // CLICK pe rândurile din tabel → setează cantitatea
      const tierRows = element.querySelectorAll('.tier-row');
      tierRows.forEach(function(row) {
        row.style.cursor = 'pointer';
        row.addEventListener('click', function() {
          const tierQuantity = parseInt(this.getAttribute('data-tier-quantity'));
          
          // Setează cantitatea în input
          quantityInput.value = tierQuantity;
          
          // Trigger change event pentru tema
          const changeEvent = new Event('change', { bubbles: true });
          quantityInput.dispatchEvent(changeEvent);
          
          // Actualizează afișajul
          updateDisplay(tierQuantity);
          
          console.log('TierPricing: Click pe rând - setată cantitatea la', tierQuantity);
        });
      });
      
      // Afișare inițială
      updateDisplay(quantityInput.value);
      
      console.log('TierPricing: Inițializat cu event listeners pentru produsul', productId);
    });
  }
  
  function getTierForQuantity(quantity, tierData) {
    // Sortează descrescător după cantitate
    const sorted = tierData.slice().sort(function(a, b) {
      return b.quantity - a.quantity;
    });
    
    // Găsește primul tier care se potrivește
    for (let i = 0; i < sorted.length; i++) {
      if (quantity >= sorted[i].quantity) {
        return sorted[i];
      }
    }
    
    // Fallback la primul tier
    return tierData[0];
  }
  
  function highlightActiveTier(tier, productId) {
    const rows = document.querySelectorAll('.product-tier-pricing[data-product-id="' + productId + '"] .tier-row');
    
    rows.forEach(function(row) {
      const rowQuantity = parseInt(row.getAttribute('data-tier-quantity'));
      
      if (rowQuantity === tier.quantity) {
        row.classList.add('active-tier');
        row.style.backgroundColor = '#e3f2fd';
        row.style.fontWeight = 'bold';
      } else {
        row.classList.remove('active-tier');
        row.style.backgroundColor = '';
        row.style.fontWeight = '';
      }
    });
  }
  
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, theme.moneyFormat || '{{amount}} lei');
    }
    
    return amount + ' lei';
  }
  
})();
